import { GET_DELIVERED_ORDERS, UPDATE_DELIVERED_ORDERS } from "./deliveredOrders.actionsTypes";
import { UPDATE_ORDER } from "../orders/order.actionsTypes";

import { ORDER_STATUSES } from "../../config/constants";

const updateDeliveredOrder = (state, order) => {
    const { status, orderId, _id, id, ...updates } = order;

    if (status === ORDER_STATUSES.CANCELED.statusId) {
        return state.filter(item => item.orderId !== orderId);
    }

    if (status !== ORDER_STATUSES.DELIVERED.statusId) {
        return state;
    }

    const orderIdentifier = _id || orderId || id;
    const existingIndex = state.findIndex(item =>
        item.orderId === orderIdentifier || item._id === orderIdentifier
    );

    if (existingIndex !== -1) {
        const updatedState = [...state];
        const existingOrder = updatedState[existingIndex];

        const updatableFields = [
            'status', 'distributor', 'eta', 'price',
            'deliveryPrice', 'shops', 'hint', 'paymentType', '__v'
        ];

        updatableFields.forEach(field => {
            if (order.hasOwnProperty(field) && existingOrder[field] !== order[field]) {
                existingOrder[field] = order[field];
            }
        });

        updatedState[existingIndex] = existingOrder;
        return updatedState;
    }

    return [order, ...state];
};

export default function deliveredOrders(state = [], action) {
	let newState = Object.assign([], state);
	switch (action.type) {
		case UPDATE_DELIVERED_ORDERS:
			action.deliveredOrder.map((order) => {
                updateDeliveredOrder(newState, order);
				return order;
			});
			return newState;
		case UPDATE_ORDER:
            return updateDeliveredOrder(newState, action.order);
		case GET_DELIVERED_ORDERS:
            return Object.assign([], action.deliveredOrders);
		default:
			return newState;
	}
}
